export function portalLinkError(value: string): string {
  if (!value.trim()) return '';
  try {
    const url = new URL(value.trim());
    if (value.length <= 2048 && !/[\s\\]/.test(value.trim()) && url.protocol === 'https:' && !url.username && !url.password && !url.port && !url.search && !url.hash && /^(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}$/i.test(url.hostname) && !/(?:^|\.)(?:localhost|local|internal|invalid|onion)$/i.test(url.hostname) && !/(?:^|\.)(?:bing\.com|google\.com|duckduckgo\.com)$/i.test(url.hostname)) return '';
  } catch { /* Show the same plain-language prerequisite for every invalid address. */ }
  return 'Use the public HTTPS portal home address, without a temporary sign-in code, query or fragment.';
}
